export const FETCH_PATIENTUSERDETAILS_INIT_ACTION =
  "FETCH_PATIENTUSERDETAILS_INIT_ACTION";
export const FETCH_PATIENTUSERDETAILS_SUCCESS_ACTION =
  FETCH_PATIENTUSERDETAILS_INIT_ACTION + "_SUCCESS";
export const FETCH_PATIENTUSERDETAILS_FAIL_ACTION =
  FETCH_PATIENTUSERDETAILS_INIT_ACTION + "_ERROR";

export const FETCH_PATIENTINACTIVE_INIT_ACTION =
  "FETCH_PATIENTINACTIVE_INIT_ACTION";
export const FETCH_PATIENTINACTIVE_SUCCESS_ACTION =
  FETCH_PATIENTINACTIVE_INIT_ACTION + "_SUCCESS";
export const FETCH_PATIENTINACTIVE_FAIL_ACTION =
  FETCH_PATIENTINACTIVE_INIT_ACTION + "_ERROR";

export const FETCH_PATIENTDETAILSVIEW_INIT_ACTION =
  "FETCH_PATIENTDETAILSVIEW_INIT_ACTION";
export const FETCH_PATIENTDETAILSVIEW_SUCCESS_ACTION =
  FETCH_PATIENTDETAILSVIEW_INIT_ACTION + "_SUCCESS";
export const FETCH_PATIENTDETAILSVIEW_FAIL_ACTION =
  FETCH_PATIENTDETAILSVIEW_INIT_ACTION + "_ERROR";

export const FETCH_PATIENTPRESCRIPTIONVIEW_INIT_ACTION =
  "FETCH_PATIENTPRESCRIPTIONVIEW_INIT_ACTION";
export const FETCH_PATIENTPRESCRIPTIONVIEW_SUCCESS_ACTION =
  FETCH_PATIENTPRESCRIPTIONVIEW_INIT_ACTION + "_SUCCESS";
export const FETCH_PATIENTPRESCRIPTIONVIEW_FAIL_ACTION =
  FETCH_PATIENTPRESCRIPTIONVIEW_INIT_ACTION + "_ERROR";

export function PatientUser(value) {
  return {
    type: FETCH_PATIENTUSERDETAILS_INIT_ACTION,
    value:value
  };
}

export function PatientsDetailsview(value) {
  return {
    type: FETCH_PATIENTDETAILSVIEW_INIT_ACTION,
    value: value
  };
}

export function PatientsInActive(value) {
  return {
    type: FETCH_PATIENTINACTIVE_INIT_ACTION,
    value: value
  };
}

export function PatientUserSlectedPage(value) {
  return {
    type: FETCH_PATIENTUSERDETAILS_INIT_ACTION,
    value: value
  };
}

export function PatientPrescriptionview(value) {
  return {
    type: FETCH_PATIENTPRESCRIPTIONVIEW_INIT_ACTION,
    value: value
  };
}

export function itempageSelected(value) {
  return {
    type: FETCH_PATIENTPRESCRIPTIONVIEW_INIT_ACTION,
    value: value
  };
}